// Client-side feature flags. Simple env-driven for now — no remote
// config, no dynamic per-user gates. Reads `REACT_APP_FLAG_*` at build
// time. Any flag not listed here defaults OFF.
//
// Flip a flag to true by setting the env var in the frontend build
// (e.g. `REACT_APP_FLAG_CLAIM_PATH_ONBOARDING=1`) and redeploying —
// nothing at runtime toggles these.

function readFlag(name, fallback = false) {
    const raw = process.env[`REACT_APP_FLAG_${name}`];
    if (raw == null) return fallback;
    return raw === '1' || raw === 'true';
}

export const FLAGS = {
    // Suppresses the welcome carousel, coach-mark tour, and
    // Try-Ask tooltip for users who signed up via the anonymous
    // try-it flow, AND swaps the free-tier quota banner for a
    // welcome state on the dashboard for their first three saves.
    // (Fix B + Fix C, Aug 2026.)
    CLAIM_PATH_ONBOARDING: readFlag('CLAIM_PATH_ONBOARDING', false),
};
